var map = {
	"./classic/LV1.webp": "d098",
	"./classic/LV2.webp": "2070",
	"./classic/LV3.webp": "057b",
	"./classic/LV4.webp": "a803",
	"./classic/LV5.webp": "8062",
	"./classic/LV6.webp": "628a",
	"./fresh/LV1.webp": "1a3f",
	"./fresh/LV2.webp": "0b7a",
	"./fresh/LV3.webp": "aada",
	"./fresh/LV4.webp": "8414",
	"./fresh/LV5.webp": "c11e",
	"./fresh/LV6.webp": "0ce4",
	"./lively/LV1.webp": "7ebb",
	"./lively/LV2.webp": "3f12",
	"./lively/LV3.webp": "a5cd",
	"./lively/LV4.webp": "ba6d",
	"./lively/LV5.webp": "2d9c",
	"./lively/LV6.webp": "c0f3",
	"./nature/LV1.webp": "89d8",
	"./nature/LV2.webp": "3404",
	"./nature/LV3.webp": "b5b4",
	"./nature/LV4.webp": "88d9",
	"./nature/LV5.webp": "e8da",
	"./nature/LV6.webp": "edd7",
	"./peaceful/LV1.webp": "9100",
	"./peaceful/LV2.webp": "7c61",
	"./peaceful/LV3.webp": "a740",
	"./peaceful/LV4.webp": "9a11",
	"./peaceful/LV5.webp": "3ac8",
	"./peaceful/LV6.webp": "3bb6",
	"./simple/LV1.webp": "5fb4",
	"./simple/LV2.webp": "71cf",
	"./simple/LV3.webp": "166c",
	"./simple/LV4.webp": "7e47",
	"./simple/LV5.webp": "3c35",
	"./simple/LV6.webp": "74a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5612";